import React from 'react';
import './Loader.css'

const Loader = ({ flag }) => {
    // const [loading, setLoading] = useState(false);

    // useEffect(() => {
    //     setLoading(true)
    // }, []);

    return (
        <div className='stride-loader z-50'>
            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
    )
}

export default Loader;